export default __webpack_public_path__ + "static/forms_compare_comp1_inactive-1-04e9a4a133e68846bbcd8021c5ef14c6.png";